

  let $maps = $('.js-map');

  if ($maps.length) {
    $maps.each(function (index, el) {
      let $map_settings = $(this);
      let map_id = $map_settings.data('map-id');
      let map_points = $('.js-map-point[data-map-id="' + map_id + '"]');

      let map_marker = $map_settings.data('marker');
      let map_center_lng = $map_settings.data('map-center-lng');
      let map_center_lat = $map_settings.data('map-center-lat');
      let map_zoom = parseInt($map_settings.data('map-zoom'));
      let map_height = parseInt($map_settings.data('map-height'));

      let markers = [];
      let info_windows = [];
      let marker_counter = 0;
      let active_info_window;

      $('#' + map_id).css('height', map_height + 'vh');

      let map = new google.maps.Map(document.getElementById(map_id), {
        center: { lat: parseFloat(map_center_lat), lng: parseFloat(map_center_lng) },
        zoom: map_zoom,
        styles: [],
        disableDefaultUI: true,
      });

      map_points.each(function () {
        let marker_lat = $(this).data('point-lat');
        let marker_lng = $(this).data('point-lng');
        let marker_title = $(this).data('marker-title');
        let marker_content = '<div class="" style="padding:10px;"><div>' + marker_title + '</div></div>';
        let marker_url = $(this).data('marker-url');

        info_windows[marker_counter] = new google.maps.InfoWindow({
          content: marker_content,
        });

        markers[marker_counter] = new google.maps.Marker({
          position: new google.maps.LatLng(marker_lat, marker_lng),
          map: map,
          animation: google.maps.Animation.DROP,
          icon: map_marker,
          title: marker_title
        });

        let this_marker = markers[marker_counter];
        let this_info_window = info_windows[marker_counter];
        google.maps.event.addListener(this_marker, 'click', function () {

          if (marker_url) {

            window.open(marker_url, '_blank');

          } else {
            if (active_info_window) {
              active_info_window.close();
            }
            this_info_window.open(map, this_marker);
            active_info_window = this_info_window;
          }

        });

        marker_counter += 1;
      })

    });

  }

